import React, { FC } from 'react';
import { Card } from '@material-ui/core';
import { Col, Row } from 'react-bootstrap';
import homeStyles from '../../../homeStyles';

export const Container: FC<{}> = ({ children }) => {
  const homeClasses = homeStyles();

  return (
    <Row>
      <Col>
        <Card className={homeClasses.container}>{children}</Card>
      </Col>
    </Row>
  );
};
